import React from 'react';
import Skeleton from 'react-loading-skeleton';

const ActivityFeedItemLoader = () => (
  <div className="bg-gray-50 border border-[#ECF2F8] rounded-lg p-3">
    <div className="flex items-start gap-3">
      <Skeleton circle width={40} height={40} />
      <div className="flex-1 gap-2">
        <Skeleton width="75%" height={16} className="mb-1" />
        <Skeleton width="50%" height={8} />
      </div>
    </div>
  </div>
);

export default ActivityFeedItemLoader;
